import React from "react";
import Layout from "../layouts/layout";
import Index from "../components/feedback";

export default function Feedback() {
  return (
    <>
      <Layout>
        <Index />
      </Layout>
    </>
  );
}
